import React from "react";
import Blog_50_7 from "../component/Blog_50_7";
function Blog_50_7_container() {
  return <Blog_50_7 />;
}

export default Blog_50_7_container;
